import React, { useState, useEffect } from "react";
import { accountService, alertService } from "../../_services";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-responsive-list";
import "react-responsive-list/assets/index.css";
import AddRolePermissionPopup from "./AddRolePermissionPopup";
import config from "../../_helpers/config";

function Roles(props) {
  console.log(props.user);
  const user = props.user; // Provide fallback if user is not defined

  const permissions = {
    IS_SCREENS_VIEW: false,
    IS_PLAYLIST_VIEW: false,
    IS_TEMPLATES_VIEW: false,
    IS_SCHEDULES_VIEW: false,
    IS_VARIETY_VIEW: false,
    IS_CATEGORY_VIEW: false,
    IS_ITEMS_VIEW: false,
    IS_INVENTORY_VIEW: false,
    IS_REPORTS_VIEW: false,
  };

  const [isRole, setIsRole] = useState(true);
  const [isPermission, setIsPermission] = useState(false);
  const [role, setRole] = useState("");
  const [permission, setPermission] = useState(permissions);
  const [roleData, setRoleData] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedRoleId, setSelectedRoleId] = useState(null);
 
  const [activeViewTab, setActiveViewTab] = useState("Digital Signage");

  function handleRole() {
    setIsRole(true);
  }
  function getRolesData() {
    try {
      const token = sessionStorage.getItem("jwtToken");

      // Set loading state
      setRoleData([]); // Clear previous data while loading

      fetch(`${config.AUTH_API_SERVER}/role?userId=${user.id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((roles) => {
          if (roles && Array.isArray(roles)) {
            console.log("Roles fetched from API:", roles);
            setRoleData(roles);
          } else {
            console.error("Invalid roles data format:", roles);
            setRoleData([]);
            alertService.error("Invalid roles data received");
          }
        })
        .catch((error) => {
          console.error("Error fetching roles:", error);
          alertService.error("Error loading roles: " + error.message);
          setRoleData([]);
        });
    } catch (err) {
      console.error("Error in getRolesData:", err);
      alertService.error("Error loading roles: " + err.message);
      setRoleData([]);
    }
  }

  // Initial data load
  useEffect(() => {
    getRolesData();
  }, []);

  const settingPermission = (perm) => {
    let permssi = { ...permission };
    permssi[`${perm}`] = !permssi[`${perm}`];
    setPermission(permssi);
  };
  const handleEditRole = (rol) => {
    try {
      // Parse the permissions from the role data
      let parsedPermissions;
      try {
        // Handle different data formats - some roles might have stringified JSON
        if (typeof rol.permissions === "string") {
          parsedPermissions = JSON.parse(rol.permissions);
          // Double parse if needed (sometimes permissions are double-stringified)
          if (typeof parsedPermissions === "string") {
            parsedPermissions = JSON.parse(parsedPermissions);
          }
        } else {
          parsedPermissions = rol.permissions;
        }
      } catch (e) {
        console.error("Error parsing role permissions:", e);
        parsedPermissions = {}; // Fallback to empty object if parsing fails
      }

      // Create a properly formatted role object to pass to the popup
      let  formattedRoleData = rol;
      formattedRoleData['permissions'] = parsedPermissions;
      
      console.log("Opening edit popup with role data:", formattedRoleData);

      props.showModalContent(
        <AddRolePermissionPopup
          roleData={formattedRoleData}
          user={user}
          onSave={(data) => {
              console.log("Role permission data for update:", data);
              getRolesData();
              props.showModal(false);
          }}
          onClose={() => props.showModal(false)}
        />,
        ""
      );
      props.showModal(true);
    } catch (err) {
      console.error("Error in edit role handler:", err);
      alertService.error("Error preparing role edit: " + err.message);
    }
  };

  const handleDeleteRole = (roleId) => {
    setShowConfirm(true);
    setSelectedRoleId(roleId);
  };
  const handleConfirm = () => {
    try {
      const token = sessionStorage.getItem("jwtToken");

      // Delete role via API
      fetch(`${config.AUTH_API_SERVER}/role/${selectedRoleId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.text();
        })
        .then(() => {
          // Refresh data and close confirmation dialog
          getRolesData();
          setShowConfirm(false);
          alertService.success("Role deleted successfully");
        })
        .catch((error) => {
          console.error("Error deleting role via API:", error);
          alertService.error("Failed to delete role: " + error.message);
          setShowConfirm(false);
        });
    } catch (err) {
      console.error("Error in delete role handler:", err);
      alertService.error("Failed to delete role: " + err.message);
      setShowConfirm(false);
    }
  };
  // Function to handle adding a new role with the popup
  const handleAddRole = () => {
    try {
      props.showModalContent(
        <AddRolePermissionPopup
          onSave={(data) => {
            try {
              console.log("Role data received from popup:", data);
              const token = sessionStorage.getItem("jwtToken");

              // Prepare data for API
              let info = {
                roleName: data.roleName,
                permissions: JSON.stringify(data.permissions),
                userId: user.id,
              };

              // Create role via API
              fetch(`${config.AUTH_API_SERVER}/role`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(info),
              })
                .then((response) => {
                  if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                  }
                  return response.json();
                })
                .then(() => {
                  // Refresh data and close modal
                  getRolesData();
                  props.showModal(false);
                  alertService.success("Role created successfully");
                })
                .catch((error) => {
                  console.error("Error creating role via API:", error);
                  alertService.error("Failed to create role: " + error.message);
                });
            } catch (err) {
              console.error("Error creating role:", err);
              alertService.error("Failed to create role: " + err.message);
            }
          }}
          onClose={() => props.showModal(false)}
        />,
        ""
      );
      props.showModal(true);
    } catch (err) {
      console.error("Error in add role handler:", err);
      alertService.error("Error preparing new role: " + err.message);
    }
  };

  const showPermissionsPopup = (role) => {
    try {

      // Parse the permissions JSON string
      let permissionData;
      try {
        permissionData = JSON.parse(role.permissions);
      } catch (e) {
        console.error("Error parsing permissions JSON:", e);
        permissionData = {};
      }

      // Handle different permission formats
      const parsedPermissions =
        typeof permissionData === "string"
          ? JSON.parse(permissionData)
          : permissionData;

      // Define the permission categories
      const permissionCategories = {
        "Digital Signage": [
          "Screens",
          "Playlist",
          "Templates",
          "Schedules",
          "Reports",
          "Media",
        ],
        "Restaurant Solution": [
          "Variety",
          "Category",
          "Items",
          "Inventory",
          "Orders",
          "Reports",
          "Customers",
          "Kitchens",
          "Expenses",
          "Settings",
        ],
      };

      const actions = ["View", "Create", "Edit", "Delete"];

      // Map the permissions to the structure used in AddRolePermissionPopup
      const mappedPermissions = {};

      // Initialize all permissions as false first
      Object.entries(permissionCategories).forEach(([module, items]) => {
        items.forEach((item) => {
          actions.forEach((action) => {
            const key = `${module}-${item}-${action}`;
            mappedPermissions[key] = false;
          });
        });
      });

      // Then set the allowed permissions to true
      Object.entries(parsedPermissions).forEach(([key, value]) => {
        if (value === true) {
          // Extract the item name and action from the permission key
          const cleanKey = key.replace(/^IS_/, "");
          let itemName = "";
          let actionType = "";

          // Determine action type
          if (cleanKey.endsWith("_VIEW") || cleanKey.endsWith("_READ")) {
            actionType = "View";
            itemName = cleanKey.replace(/_VIEW$|_READ$/, "");
          } else if (
            cleanKey.endsWith("_CREATE") ||
            cleanKey.endsWith("_ADD")
          ) {
            actionType = "Create";
            itemName = cleanKey.replace(/_CREATE$|_ADD$/, "");
          } else if (cleanKey.endsWith("_EDIT")) {
            actionType = "Edit";
            itemName = cleanKey.replace(/_EDIT$/, "");
          } else if (cleanKey.endsWith("_DELETE")) {
            actionType = "Delete";
            itemName = cleanKey.replace(/_DELETE$/, "");
          }

          // Find which category this permission belongs to
          for (const [module, items] of Object.entries(permissionCategories)) {
            const matchedItem = items.find(
              (item) =>
                itemName === item.toUpperCase() ||
                // Special handling for some common mappings
                (itemName === "SCREENS" && item === "Screens") ||
                (itemName === "PLAYLIST" && item === "Playlist") ||
                (itemName === "CATEGORY" && item === "Category") ||
                (itemName === "ITEMS" && item === "Items")
            );

            if (matchedItem) {
              const permKey = `${module}-${matchedItem}-${actionType}`;
              mappedPermissions[permKey] = true;
              break; // Found a match, no need to continue searching
            }
          }
        }
      });

      props.showModalContent(
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(4px)",
            zIndex: 9999,
            overflowY: "auto" ,
            paddingTop:0,
            paddingBottom: 0,
          }}
          onClick={(e) => {
            // Close when clicking the backdrop but not when clicking the modal content
            if (e.target === e.currentTarget) {
              props.showModal(false);
            }
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
              width: "95%",
              maxWidth: "1000px",
              maxHeight: "85vh",
              overflowY: "auto",
              padding: 0,
              animation: "fadeIn 0.3s ease-out",
            }}
          >
            {/* Header with gradient */}
            <div
              style={{
                background: "#f8fafc",
                borderBottom: "1px solid #e2e8f0",
                padding:"16px 24px",
                borderRadius: "12px 12px 0 0",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h2
                style={{
                  fontSize: "20px",
                  color: "#334155",
                  fontWeight: "600",
                  margin: 0,
                }}
              >
                Role Permissions: {role.roleName}
              </h2>
              <button
                type="button"
                onClick={() => props.showModal(false)}
                aria-label="Close"
                style={{
                  background: "#f1f5f9",
                  color: "#64748b",
                  width: "36px",
                  height: "36px",
                  borderRadius: "6px",
                  border: "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  transition: "all 0.2s",
                  zIndex: 1000,
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.background = "#e2e8f0";
                  e.currentTarget.style.color = "#334155";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background = "#f1f5f9";
                  e.currentTarget.style.color = "#64748b";
                }}
              >
                ×
              </button>
            </div>

            {/* Content Area */}
            <div style={{ padding:  "30px" }}>
              {/* Mobile Tab Selector (visible only on small screens) */}

              {/* Permissions Tables - Side by Side on Desktop, Tabbed on Mobile */}
              <div
                style={{
                  display: "flex",
                  flexDirection:"row",
                  gap: "24px",
                  flexWrap: "wrap",
                }}
              >
                {Object.entries(permissionCategories).map(([module, items]) => (
                  <div
                    key={module}
                    style={{
                      flex: 1,
                      minWidth: "300px",
                      border: "1px solid #e2e8f0",
                      borderRadius: "6px",
                      overflow: "hidden",
                      marginBottom: "16px",
                      display:"block",
                    }}
                  >
                    {/* Module Header */}
                    <div
                      style={{
                        backgroundColor: "#f1f5f9",
                        color: "#334155",
                        padding: "10px 12px",
                        borderBottom: "1px solid #e2e8f0",
                        fontWeight: "600",
                        fontSize:  "16px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginBottom: "0",
                      }}
                    >
                      {module}
                    </div>

                    <div
                      style={{
                        padding: "10px",
                        overflowX: "auto",
                        WebkitOverflowScrolling: "touch",
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          minWidth:  "auto",
                        }}
                      >
                        <thead>
                          <tr
                            style={{
                              borderBottom: "1px solid #e2e8f0",
                              fontWeight: "bold",
                            }}
                          >
                            <th
                              style={{
                                padding:  "10px 8px",
                                textAlign: "left",
                                fontSize:  "14px",
                                width:  "40%",
                                color: "#475569",
                              }}
                            >
                              Permission
                            </th>
                            {actions.map((action, index) => (
                              <th
                                key={action}
                                style={{
                                  padding: "10px 5px",
                                  textAlign: "center",
                                  fontSize: "14px",
                                  color: "#475569",
                                }}
                              >
                                {action}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {items.map((item) => (
                            <tr
                              key={item}
                              style={{
                                borderBottom: "1px solid #f1f5f9",
                                transition: "all 0.2s",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#f8fafc";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "transparent";
                              }}
                            >
                              <td
                                style={{
                                  padding:  "10px 8px",
                                  fontWeight: "500",
                                  fontSize: "14px",
                                  color: "#334155",
                                }}
                              >
                                {item}
                              </td>
                              {actions.map((action) => {
                                const permKey = `${module}-${item}-${action}`;
                                const isAllowed =
                                  mappedPermissions[permKey] === true;

                                return (
                                  <td
                                    key={action}
                                    style={{
                                      textAlign: "center",
                                      padding: "8px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      {isAllowed ? (
                                        <span
                                          style={{
                                            padding:
                                             "4px 8px",
                                            borderRadius: "4px",
                                            backgroundColor: "#dcfce7",
                                            color: "#166534",
                                            border: "1px solid #bbf7d0",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "4px",
                                            fontSize: "12px",
                                            fontWeight: "500",
                                            userSelect: "none",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          <i
                                            className="fa fa-check"
                                            style={{
                                              fontSize: "10px",
                                            }}
                                          ></i>
                                          { "Allowed"}
                                        </span>
                                      ) : (
                                        <span
                                          style={{
                                            padding: "4px 8px",
                                            borderRadius: "4px",
                                            backgroundColor: "#fef2f2",
                                            color: "#991b1b",
                                            border: "1px solid #fecaca",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "4px",
                                            fontSize:"12px",
                                            fontWeight: "500",
                                            userSelect: "none",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          <i
                                            className="fa fa-times"
                                            style={{
                                              fontSize:"10px",
                                            }}
                                          ></i>
                                          {"Denied"}
                                        </span>
                                      )}
                                    </div>
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ))}
              </div>

              {/* Close Button */}
              <div
                style={{
                  textAlign: "right",
                  marginTop: "30px",
                  borderTop: "1px solid #e2e8f0",
                  paddingTop: "20px",
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <button
                  onClick={() => props.showModal(false)}
                  style={{
                    backgroundColor: "#3b82f6",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    padding:  "10px 24px",
                    fontSize:  "16px",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition: "all 0.2s",
                    boxShadow: "0 2px 4px -1px rgba(59, 130, 246, 0.5)",
                  }}
                  onMouseOver={(e) =>
                    (e.target.style.backgroundColor = "#2563eb")
                  }
                  onMouseOut={(e) =>
                    (e.target.style.backgroundColor = "#3b82f6")
                  }
                >
                  Close
                </button>
              </div>
            </div>
          </div>

          <style>{`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          
          @media (max-width: 768px) {
            .custom-modal-content {
              width: 95%;
              max-height: unset;
              margin: 10px auto;
            }
            
            .permission-tag {
              font-size: 11px !important;
              padding: 3px 6px !important;
            }
            
            table th, table td {
              padding: 8px 4px !important;
            }
          }
          
          @media (max-width: 480px) {
            table {
              font-size: 11px;
            }
            
            th, td {
              padding: 3px 2px !important;
            }
          }
        `}</style>
        </div>,
        "Role Permissions"
      );
      props.showModal(true);
    } catch (err) {
      console.error("Error showing permissions popup:", err);
      alertService.error("Error displaying permissions: " + err.message);
    }
  };

  // Create the roles list display
  const showRolesList = () => {
    try {
      if (!roleData || roleData.length === 0) {
        return (
          <div className="no-data-message">
            <p>No roles found. Create a new role to get started.</p>
          </div>
        );
      }

      return (
        <div>
          <Table
            cellPadding="5px"
            cellSpacing="3px"
            style={{ width: "100%", marginTop: "10px" }}
          >
            <Thead>
              <Tr>
                <Th style={{ width:  "50%" }}>Role Title</Th>
                <Th
                  style={{
                    width:  "50%",
                    textAlign: "right",
                  }}
                >
                  Actions
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {roleData.map((rol) => (
                <Tr key={rol.id}>
                  <Td>
                    <span
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        fontSize: "16px",
                        wordBreak:"normal",
                        textAlign:"left"
                      }}
                    >
                      {rol.roleName}
                    </span>
                  </Td>
         
                  <Td>
                    <div
                      className={`role-actions`}
                      style={{ justifyContent: "flex-end" }}
                    >
                                 <i style={{color:"red", cursor:"pointer", marginRight:"20px"}} class="bi bi-trash" onClick={() => handleDeleteRole(rol.id)}></i>

                                 <i style={{ cursor:"pointer", marginRight:"20px"}} class="bi bi-pencil-fill" onClick={() => handleEditRole(rol)}></i>
                                   <i style={{ cursor:"pointer", marginRight:"20px"}} class="bi bi-eye-fill" onClick={() => showPermissionsPopup(rol)}></i>
                                </div>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </div>
      );
    } catch (err) {
      console.error("Error displaying roles list:", err);
      return (
        <div className="error-message">
          <p>Error loading roles. Please try refreshing the page.</p>
        </div>
      );
    }
  };

  return (
    <div className="role-management-container">
      <div >
        <div > 
          <div className="personal-details-header">
            <h4 className="personal-details-title">
              Roles & Permissions
            </h4>
            <button
              onClick={handleAddRole}
              className="reset-password-btn"
              style={{
                padding:"8px 16px",
                fontSize: "14px",
              }}
            >
              <i class="bi bi-plus-square" style={{ marginRight: "6px" }}></i>
              { "Add New Role"}
            </button>
          </div>
          
          <div className="personal-details-content">
            <div className="roles-list-container">
              {showRolesList()}
            </div>
          </div>
        </div>
      </div>

      {showConfirm && (
        <div className="dialog-overlay">
          <div className="dialog">
            <h3>Warning!!</h3>
            <p>Are you sure you want to delete this role?</p>
            <div>
              <button className="confirm" onClick={handleConfirm}>
                Yes
              </button>
              <button className="cancel" onClick={() => setShowConfirm(false)}>
                No
              </button>
            </div>
          </div>
        </div>
      )}
      
      <style jsx="true">{`
        .role-management-container {
          margin-bottom: 30px;
          width: 100%;
        }
        
        .roles-list-container {
          background-color: transparent;
          border-radius: 0;
          box-shadow: none;
          overflow-x: auto;
          padding: 0;
        }
        
        .no-roles-message,
        .no-data-message,
        .error-message {
          padding: 20px;
          text-align: center;
          color: #666;
          background: #fff;
          border-radius: none;
          border:none;
        }
        
        .error-message {
          color: #dc2626;
          background: #fef2f2;
          border-color: #fecaca;
        }
        
        .role-actions {
          display: flex;
          gap: 12px;
          justify-content: flex-end;
          flex-wrap: wrap;
          padding: 12px 0;
        }
        
        .role-actions-mobile {
          gap: 10px;
        }
        
        .action-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 14px 24px;
          border-radius: 8px;
          border: none;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          font-size: 14px;
          font-weight: 600;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          min-width: 85px;
          letter-spacing: 0.025em;
          text-decoration: none;
          position: relative;
          overflow: hidden;
        }
        
        .action-btn::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.2) 50%,
            rgba(255, 255, 255, 0) 100%
          );
          transition: left 0.6s;
        }
        
        .action-btn:hover::before {
          left: 100%;
        }
        
        .roles-table-mobile .action-btn {
          padding: 10px 16px;
          min-width: 60px;
          font-size: 12px;
          gap: 6px;
        }
        
        .roles-table-mobile .view-btn {
          padding: 14px 22px !important;
          min-width: 80px !important;
          font-size: 12px;
          gap: 8px;
        }
        
        .view-btn {
          background: linear-gradient(135deg, #10b981 0%, #059669 100%);
          color: white;
          border: 1px solid #059669;
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);
          padding: 18px 32px !important;
          min-width: 120px !important;
        }
        
        .view-btn:hover {
          background: linear-gradient(135deg,rgb(8, 188, 131) 0%,rgb(21, 160, 121) 100%);
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(16, 185, 129, 0.4);
        }
        
        .view-btn:active {
          transform: translateY(0);
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
        }
        
        .view-btn i {
          font-size: 14px;
          color: white;
        }
        
        .edit-btn {
          background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
          color: white;
          border: 1px solid #2563eb;
          box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
        }
        
        .edit-btn:hover {
          background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(59, 130, 246, 0.4);
        }
        
        .edit-btn:active {
          transform: translateY(0);
          box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
        }
        
        .edit-btn i {
          font-size: 14px;
          color: white;
        }
        
        .delete-btn {
          background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
          color: white;
          border: 1px solid #dc2626;
          box-shadow: 0 4px 12px rgba(239, 68, 68, 0.25);
        }
        
        .delete-btn:hover {
          background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(239, 68, 68, 0.4);
        }
        
        .delete-btn:active {
          transform: translateY(0);
          box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
        }
        
        .delete-btn i {
          font-size: 14px;
          color: white;
        }
        
        /* Table styling to match personal details */
   
        
        .roles-list-container thead {
          border-bottom: 1px solid #e5e7eb;
        }
        
        
        /* Role title styling */
        .roles-list-container td span {
          font-weight: 500;
          color: #1f2937;
          font-size: 15px;
        }
        
      
      `}</style>
    </div>
  );
}

export { Roles };
